import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_ClientRights = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_ClientRights' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>CLIENT RIGHTS</h3></p>

                <p className='w-750'>
                    It is the policy of Lilly Pad Home Health Agency that the rights of the client shall be understood, respected, and preserved. In general, these rights shall include, but shall not be limited to, the right of dignity, human care and treatment and proper assistance and guidance.
                </p>

                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    <ol>
                        <li>Exercise his/her right as a client and citizer;</li>
                        <li>Be fully informed of his/her rights and responsibilities and the rules and regulations governing conduct and responsibilites;</li>
                        <li>To be treated with respect, consideration, dignity and full recognition of his/her individuality and right to privacy;</li>
                        <li>To receive care and services which are adequate, appropriate, and in compliance with relevant Federal and State laws and regulations;</li>
                        <li>To receive upon admission and during his/her stay a written statement of the services provided by the facility;</li>
                        <li>Voice grievances and recommend changes in policies and service through facility staff and/or through outside representatives, and to do so without restraint, interference, coercion, discrimination or reprisal;</li>
                        <li>To be free to mental and physical abuse, neglect and exploitation;</li>
                        <li>Privacy for visits of his/her family if no other mandates are involved;</li>
                        <li>Except in emergencies, to be free from chemical and physical restraint unless authorized for a specific period of time by a physician according to clear and indicated medical need;</li>
                        <li>Receive or refuse visitors at any reasonable hour;</li>
                        <li>Make scheduled trips into community;</li>
                        <li>Participate in recreation, physical exercise and outdoor activities on a regular basis;</li>
                        <li>Wear, keep and use his/her clothing, personal hygiene items and personal possissions;</li>
                        <li>To have his/her personal and medical records kept confidential and revealed only with his/her written consent or as required by State or Federal law or regulation;</li>
                        <li>Be free from the loss of any meal or a portion of meal as a disciplinary action;</li>
                        <li>Have access to all living areas, recreational areas, and habilitative supplies and equipment;</li>
                        <li>Communicate and meet with persons of his/her own choice upon mutual consent and under appropriate supervision;</li>
                        <li>Live and work in an unlocked environment during waking hours;</li>
                        <li>Have access to individual lockable storage space for his/her private use;</li>
                        <li>Be free from mistreatment, abuse, neglect or exploitation in any form;</li>
                        <li>Be paid for work performed that is not part of his/her habilitation plan;</li>
                        <li>To receive a reasonable response to his her request from the facility administrator, director and staff;</li>
                        <li>Be free from unreasonable or excessive compensation for damage resulting from his/her behavior;</li>
                        <li>Obtain and/or retain a driver's license, unless prohibited;</li>
                        <li>Receive written notice and rationale if transferred within another facility;</li>
                        <li>Have no unauthorized publicity on, use of, or discussion of his/her care, treatment, or records unless informed consent is given;</li>
                        <li>Be assured that no information shall be released form his/her record unless written informed consent is given;</li>
                        <li>Be involved in research only upon given informed, voluntary consent;</li>
                        <li>Be free from treatment involve aversive conditioning, experimental drug or procedures, and non-emergency surgery, unless informed, voluntary consent or written consent of the guardian is given;</li>
                        <li>Be free from physical and chemical restraint unless informed consent is given, and when authorized in writing by physician for use during behavior modification sessions;</li>
                        <li>Exercise all civil rights;</li>
                        <li>Communicate and consult with the individual or agency having legal custody;</li>
                        <li>Communicate and consult with legal counsel of his/her guardian's choice, at his/her expense;</li>
                        <li>Have access to adequate private facilities for daily hygiene and grooming purposes;</li>
                        <li>Access to barber or beautician services;</li>
                        <li>Participate in religious worship of his/her choice;</li>
                        <li>Keep and spend a reasonable sum of his/her own money;</li>
                        <li>To have access to any reasonable hour to a telephone where he/she may speak privately;</li>
                        <li>To send and receive mail promptly and unopened, unless the resident requests that someone open and read mail; and to have access at his/her expense to writing instruments, stationary and postage.</li>
                        <li>To be encouraged to exercise his or her rights as resident and citizens, and to be permitted to make complaints and suggestions without feat of coercion or retaliation;</li>
                        <li>To have use of his/her own possessions where reasonable and have accessible, lockable space provided for security or personal valuables. This space shall be accessible only to the residents and the program director;</li>
                        <li>To manage his/her personal needs funds unless such authority has been delegated to another. If authority to manage personal funds has been delegated to the facility; the resident has the right to examine the account at any time;</li>
                        <li>To be notified when the facility issues a provisional license by the governing body for authentication and the basis on which the provisional licensed was issued. The resident's responsible family member or guardian shall be notified;</li>
                        <li>To have freedom to participate by choice in accessible community activities and in social, political, medical and religious resources and to have freedom to refuse such participation;</li>
                        <li>To receive upon admission to the facility a copy of this section.</li>
                    </ol>
                </p>

                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    I, &nbsp;<input type='text' name='txtRelationship' id='txtRelationship' className='add-only w-200 custom-add-only' />, have read or have been explained the Client's Rights Policy and have been given a copy for my records.
                </p>
                <p className='w-750'>
                    This Client's Right Policy is valid from &nbsp;<input type='date' name='txtRelationship1' id='txtRelationship1' className='add-only w-200 custom-add-only' />
                    &nbsp; to &nbsp;
                    <input type='date' name='txtRelationship2' id='txtRelationship2' className='add-only w-200 custom-add-only' />.
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Client/Guardian Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Administrative Signature </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











